<script setup lang="ts">
/**
 * Subscription tag for the payments table: the plan name on the soft green band
 * used across the app, or a faint dash when the payment has no subscription (the
 * same placeholder `MoneyCell` shows for a missing amount, so a mostly empty
 * column stays scannable).
 */
withDefaults(
  defineProps<{
    /** Plan name; empty/undefined renders the placeholder. */
    name?: string | null
  }>(),
  { name: null },
)
</script>

<template>
  <td class="font-tufte">
    <span v-if="name" class="subscription-tag">{{ name }}</span>
    <span v-else class="text-tufte-muted">–</span>
  </td>
</template>

<style scoped>
.subscription-tag {
  display: inline-block;
  background: var(--color-subscription-band);
  color: var(--color-subscription-ink);
  font-family: var(--font-tufte-sans);
  font-size: 0.78rem;
  letter-spacing: 0.04em;
  padding: 0.08rem 0.42rem;
  white-space: nowrap;
}
</style>
